import { Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../ui/alert-dialog";

export function DataManagementSection({ onClearData }) {
  return (
    <div className="card-base p-6">
      <h2 className="text-lg font-semibold text-white font-['Outfit'] mb-4 flex items-center gap-2">
        <Trash2 size={20} className="text-red-400" />
        Data Management
      </h2>

      <div className="space-y-4">
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <div className="flex items-center justify-between p-4 rounded-xl bg-slate-800/50 cursor-pointer hover:bg-slate-800 transition-colors">
              <div>
                <p className="text-white font-medium">Clear All Data</p>
                <p className="text-sm text-slate-400">
                  Remove all tasks, events, and members
                </p>
              </div>
              <Button
                variant="destructive"
                className="bg-red-600 hover:bg-red-500"
                data-testid="clear-data-button"
              >
                <Trash2 size={16} className="mr-2" />
                Clear
              </Button>
            </div>
          </AlertDialogTrigger>
          <AlertDialogContent className="bg-slate-900 border-slate-800">
            <AlertDialogHeader>
              <AlertDialogTitle className="text-white">
                Are you sure?
              </AlertDialogTitle>
              <AlertDialogDescription className="text-slate-400">
                This action cannot be undone. This will permanently delete all
                your tasks, events, family members, and device settings.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel
                className="border-slate-700"
                data-testid="cancel-clear-data"
              >
                Cancel
              </AlertDialogCancel>
              <AlertDialogAction
                onClick={onClearData}
                className="bg-red-600 hover:bg-red-500"
                data-testid="confirm-clear-data"
              >
                Delete All
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </div>
  );
}
